import React, { useState, useEffect } from "react";
import "./Account.scss";
import { useNavigate } from "react-router-dom";
import {
  updatePasswordUser,
  updateUserProfile,
} from "../../../api/userService";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-hot-toast"; // <-- Usamos react-hot-toast
import useAuth from "../../../api/useAuth";
import { fetchDashboardData } from "../../../redux/actions/dashboardActions";
import { useDispatch } from "react-redux";
import PictureInitials from "../../Menu/PictureInitials/PictureInitials";
import ColorPicker from "../../ColorPicker/ColorPicker";

import { MdSave, MdLogout } from "react-icons/md";

const Account = ({ dashboardData }) => {
  const { logout } = useAuth();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordVisibility, setPasswordVisibility] = useState({
    current: false,
    new: false,
    confirm: false,
  });
  const [colorSession, setColorSession] = useState("#FF0000");
  const [colorReference, setColorReference] = useState("#0000FF");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const subscriptionEndDate = new Date(
    dashboardData.user.subscription_end_date,
  );
  const isSubscriptionActive = subscriptionEndDate > new Date();

  const formattedDate = subscriptionEndDate.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const togglePasswordVisibility = (field) => {
    if (!["current", "new", "confirm"].includes(field)) {
      console.error(`El campo ${field} no es válido.`);
      return;
    }

    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  useEffect(() => {
    if (dashboardData && dashboardData.user) {
      setFirstName(dashboardData.user.first_name || "");
      setLastName(dashboardData.user.last_name || "");
      setEmail(dashboardData.user.email || "");
      setPhone(dashboardData.user.phone_number || "");
      setColorSession(dashboardData.user.color_session || "#FF0000");
      setColorReference(dashboardData.user.color_reference || "#0000FF");
    }
  }, [dashboardData]);

  const onLogout = () => {
    logout();
    setTimeout(() => {
      navigate("/login");
    }, 1000);
  };

  const updateUser = () => {
    if (
      dashboardData.user.first_name !== firstName ||
      dashboardData.user.last_name !== lastName ||
      dashboardData.user.email !== email ||
      dashboardData.user.phone_number !== phone ||
      dashboardData.user.color_session !== colorSession ||
      dashboardData.user.color_reference !== colorReference
    ) {
      let usuario = { ...dashboardData.user };
      usuario.first_name = firstName;
      usuario.last_name = lastName;
      usuario.email = email;
      usuario.phone_number = phone;
      usuario.color_session = colorSession;
      usuario.color_reference = colorReference;

      updateUserProfile(dashboardData.user._id, usuario)
        .then(() => {
          dispatch(fetchDashboardData());
          toast.success("User updated successfully.", {
            position: "top-center",
          });
        })
        .catch(() => {
          toast.error("There was a problem updating user. Try again.", {
            position: "top-center",
          });
        });
    }

    // Validar que todos los campos estén llenos
    if (!currentPassword || !newPassword || !confirmPassword) {
      // Si quieres notificar:
      // toast.error('Please fill out all password fields.', { position: 'top-center' });
      return;
    }

    // Validar que las contraseñas nuevas coincidan
    if (newPassword !== confirmPassword) {
      toast.error("The new password and the confirmation do not match.", {
        position: "top-center",
      });
      return;
    }

    // Llamar a la función para actualizar la contraseña
    updatePasswordUser(
      dashboardData.user._id,
      currentPassword,
      newPassword,
      confirmPassword,
    )
    .then(() => {
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      dispatch(fetchDashboardData());
      toast.success("Password updated successfully.", {
        position: "top-center",
      });
    })
    .catch(() => {
      toast.error("There was a problem updating the password. Try again.", {
        position: "top-center",
      });
    });
  };

  return (
    <div className="account">
      <div className="profileSettings-row">
        <div>
          <h1>Account</h1>
          <h3>Manage your account</h3>
        </div>
        <div className="profileSettings-row-profile-img">
          <div className="profile-image">
            <PictureInitials
              first_name={dashboardData?.user.first_name}
              last_name={dashboardData?.user.last_name}
            />
          </div>
        </div>
      </div>

      <div className="account-row"> {/* account-row-bottom */}
        <div className="account-input-contain">
          <div className="account-input">
            <p>First name</p>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
          <div className="account-input">
            <p>Last name</p>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
        </div>
        <div className="account-input-contain">
          <div className="account-input">
            <p>Email</p>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="account-input">
            <p>Phone</p>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
        </div>
        <div className="account-input-contain">
          <div className="account-input-contain">
            <div className="account-input" style={{ position: "relative" }}>
              <p>Current password</p>
              <input
                type={passwordVisibility.current ? "text" : "password"}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="password"
              />
              <button
                type="button"
                onClick={() => togglePasswordVisibility("current")}
                className="toggle-password-btn"
              >
                {passwordVisibility.current ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            <div className="account-input" style={{ position: "relative" }}>
              <p>New password</p>
              <input
                type={passwordVisibility.new ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="password"
              />
              <button
                type="button"
                onClick={() => togglePasswordVisibility("new")}
                className="toggle-password-btn"
              >
                {passwordVisibility.new ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            <div className="account-input" style={{ position: "relative" }}>
              <p>Confirm new password</p>
              <input
                type={passwordVisibility.confirm ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="password"
              />
              <button
                type="button"
                onClick={() => togglePasswordVisibility("confirm")}
                className="toggle-password-btn"
              >
                {passwordVisibility.confirm ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="account-row account-row-bottom">
        <h1>Report colors</h1>
        <div className="account-input-contain">
          <div className="account-input-colorpicker">
            <p>Session</p>
            <p></p>
            <ColorPicker color={colorSession} onChange={setColorSession} />
          </div>
          <div className="account-input-colorpicker">
            <p>Reference</p>
            <p></p>
            <ColorPicker color={colorReference} onChange={setColorReference} />
          </div>
          <div className="account-input-save">
            <button className="btn-save" onClick={updateUser}>
              <MdSave size={22}/>
              Save
            </button>
          </div>
        </div>
      </div>

      <div className="account-options-end">
        <div>
          <p>Subscription type</p>
          <p>
            {dashboardData?.user?.subscription || "No Subscription Found"}
          </p>
        </div>
        <div>
          <p>Active Subscription</p>
          <p>
            {isSubscriptionActive
              ? "Until " + formattedDate
              : "No Active Subscription"}
          </p>
        </div>
        <div>
          <p>Reports Generated</p>
          <p>
            {dashboardData?.user?.reports_generated}/
            {dashboardData?.max_reports}
          </p>
        </div>
      </div>

      <div className="btn-logout-settings">
        <button className="btn-logout" onClick={onLogout}>
          <MdLogout size={22}/>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Account;
